import { Component, Input, OnDestroy, type OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ReelsService } from '../../../../../services/reels.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
	selector: 'app-import-reel',
	templateUrl: './import-reel.component.html',
	styleUrls: ['./import-reel.component.scss']
})
export class ImportReelComponent implements OnInit, OnDestroy {
	@Input() data: any = {};
	selectedReel: any;
	reels: any;

	ref: DynamicDialogRef | undefined;
	private atComponentDestroy = new Subject();

	constructor(public modalRef: BsModalRef, private reelsService: ReelsService) {

	}

	ngOnInit(): void {
		this.reelsService.datatable().subscribe(((response: any) => {
			this.reels = response;
		}));
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
		if (this.ref) {
			this.ref.close();
		}
	}

	/**
	 * Send data to the server
	 */
	submit(): void {
		this.reelsService.saveMedias(
			{
				sourceReel: this.selectedReel,
				importMedias: true
			}, this.data.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				data => {
					this.modalRef.hide();
				}
			);
	}

}
